<template>
  <Tab no-close @close="removeCurrent">
    <template #container>
      <!-- ------------------------ user ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="menu/user/page" name="user">
        <template #menu>
          <div v-if="false" class="float-right" style="position:relative; top:-5px;">
            <v-btn v-if="isRowView" :title="$t('menu.organized.grid')" color="primary" icon @click="mainMenuByGrid">
              <v-icon small>fas fa-th</v-icon>
            </v-btn>
            <v-btn v-if="isGridView" :title="$t('menu.organized.row')" color="primary" icon @click="mainMenuByRow">
              <v-icon small>fas fa-th-list</v-icon>
            </v-btn>
          </div>
        </template>
        <template #content>
          <v-container>
            <v-row>
              <!-- Social -->
              <div v-if="false">
                <hr v-if="!isGridView" class="sr-hr-menu" />
                <v-col cols="12" md="3">
                  <v-card class="sr-menu-btn text-center mx-auto elevation-8" hover width="135" @click="social">
                    <v-icon class="mt-4" color="primary">fa-share-alt-square</v-icon>
                    <v-card-text>{{ $t("dashboard.social.title") }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col v-if="!isGridView" class="d-flex align-center" cols="12" md="9">
                  <DocumentationDiv icon="false" path="menu/user/social" :key="$i18n.locale"/>
                </v-col>
              </div>
              <!-- Feed Removed 29/10/22 -->
              <div v-if="false">
                <hr v-if="!isGridView" class="sr-hr-menu" />
                <v-col cols="12" md="3">
                  <v-card class="sr-menu-btn text-center mx-auto elevation-8" hover width="135" @click="feed">
                    <v-icon class="mt-4" color="primary">fa-stream</v-icon>
                    <v-card-text>{{ $t("dashboard.feed.title") }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col v-if="!isGridView" class="d-flex align-center" cols="12" md="9">
                  <DocumentationDiv icon="false" path="menu/user/feed" :key="$i18n.locale"/>
                </v-col>
              </div>
              <!-- Extension Removed 29/10/22 -->
              <div v-if="false">
                <hr v-if="!isGridView" class="sr-hr-menu" />
                <v-col cols="12" md="3">
                  <v-card class="sr-menu-btn text-center mx-auto elevation-8" hover width="135" @click="extension">
                    <v-icon class="mt-4" color="primary">fab fa-chrome</v-icon>
                    <v-card-text>{{ $t("dashboard.extension.title") }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col v-if="!isGridView" class="d-flex align-center" cols="12" md="9">
                  <DocumentationDiv icon="false" path="menu/user/extension" :key="$i18n.locale"/>
                </v-col>
              </div>
            </v-row>
            <v-row>
              <!-- Account -->
              <hr v-if="!isGridView" class="sr-hr-menu" />
              <v-col cols="12" md="3">
                <v-card class="sr-menu-btn text-center mx-auto elevation-8" hover width="135" @click="account">
                  <v-icon class="mt-4" color="primary">fa-user</v-icon>
                  <v-card-text>{{ $t("dashboard.account.title") }}</v-card-text>
                </v-card>
              </v-col>
              <v-col class="d-flex align-center" cols="12" md="9">
                <DocumentationDiv icon="false" path="menu/user/account" :key="$i18n.locale" />
              </v-col>
              <!-- Reviews -->
              <hr v-if="!isGridView" class="sr-hr-menu" />
              <v-col cols="12" md="3">
                <v-card class="sr-menu-btn text-center mx-auto elevation-8" hover width="135" @click="reviews">
                  <v-icon class="mt-4" color="primary">fa-splotch</v-icon>
                  <v-card-text>{{ $t("dashboard.reviews.title") }}</v-card-text>
                </v-card>
              </v-col>
              <v-col class="d-flex align-center" cols="12" md="9">
                <DocumentationDiv icon="false" path="menu/user/reviews" :key="$i18n.locale"/>
              </v-col>

              <!-- STORIES Removed 29/10/22 -->
              <div v-if="false">
                <hr v-if="!isGridView" class="sr-hr-menu" />
                <v-col cols="12" md="3">
                  <v-card :class="['sr-menu-btn text-center mx-auto elevation-8']" hover width="135" @click="stories">
                    <v-icon class="mt-4" color="primary">fa-book</v-icon>
                    <v-card-text>{{ $t("dashboard.stories.title") }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col class="d-flex-row align-center" cols="12" md="9">
                  <DocumentationDiv icon="false" path="menu/user/stories" :key="$i18n.locale"/>
                </v-col>
              </div>

              <!-- User groups Removed 29/10/22 -->
              <div v-if="false">
                <hr v-if="!isGridView" class="sr-hr-menu" />
                <v-col cols="6" md="3">
                  <v-card class="sr-menu-btn text-center mx-auto elevation-8" hover width="135" @click="groups">
                    <v-icon class="mt-4" color="primary">fa-users</v-icon>
                    <v-card-text>{{ $t("dashboard.groups.title") }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col v-if="!isGridView" class="d-flex align-center" cols="12" md="8">
                  <DocumentationDiv icon="false" path="menu/user/groups" :key="$i18n.locale"/>
                </v-col>
              </div>

              <!-- Notfications -->
              <div class="tw-hidden">
                <hr v-if="!isGridView" class="sr-hr-menu" />
                <v-col cols="6" md="4">
                  <v-card id="notification_menu" class="sr-menu-btn elevation-8" hover @click="notifications">
                    <v-icon class="mt-4" color="primary">fa-bell</v-icon>
                    <v-card-text>{{ $t("dashboard.notifications.title") }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col v-if="!isGridView" class="d-flex align-center" cols="12" md="8">
                  <DocumentationDiv icon="false" path="menu/company/notifications" :key="$i18n.locale"/>
                </v-col>
              </div>

              <!-- documentation -->
              <div class="tw-hidden">
                <hr v-if="!isGridView && isSecuratingAccount" class="sr-hr-menu" />
                <v-col v-if="isSecuratingAccount" cols="6" md="4">
                  <v-card id="documentation_menu" class="sr-menu-btn elevation-8" hover @click="documentation">
                    <v-icon class="mt-4" color="primary">fa-question-circle</v-icon>
                    <v-card-text>{{ $t("dashboard.documentation.title") }}</v-card-text>
                  </v-card>
                </v-col>
                <v-col v-if="!isGridView && isSecuratingAccount" class="d-flex align-center" cols="12" md="8">
                  <DocumentationDiv icon="false" path="menu/company/documentation" :key="$i18n.locale"/>
                </v-col>
              </div>
            </v-row>
          </v-container>
        </template>
      </TabPage>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"

export default {
  name: "Menu",
  mixins: [tab],
  data: () => ({
    menu: "menu",
    pages: ["user"],
    page: "user",
  }),
  mounted() {
    if (window.location.href.match(/notifications$/)) {
      this.notifications()
    }

    if (window.location.href.match(/bookmarks$/)) {
      //-- The account.mounted() will launch the bookmark page
      this.account()
    }

    if (window.location.href.match(/stories/)) {
      this.stories()
    }
  },
  computed: {
    isSecuratingAccount() {
      return this.$store.state.auth.user["doc"] === true
    },
    isGridView() {
      return this.$store.state.application.currentMenuStyle === this.$store.state.application.menuStyles.GRID
    },
    isRowView() {
      return this.$store.state.application.currentMenuStyle === this.$store.state.application.menuStyles.ROW
    },
  },
  methods: {
    mainMenuByRow() {
      this.$store.state.application.currentMenuStyle = this.$store.state.application.menuStyles.ROW
    },
    mainMenuByGrid() {
      this.$store.state.application.currentMenuStyle = this.$store.state.application.menuStyles.GRID
    },
    account() {
      this.push({
        singleton: true,
        name: "dashboard.account.title",
        component: "Account",
      })
    },
    social() {
      this.push({
        singleton: true,
        name: "dashboard.social.title",
        component: "Social",
      })
    },
    reviews() {
      this.push({
        singleton: true,
        name: "dashboard.reviews.title",
        component: "Reviews",
      })
    },
    feed() {
      this.push({
        singleton: true,
        name: "dashboard.feed.title",
        component: "Feed",
      })
    },
    stories() {
      this.push({
        singleton: true,
        name: "dashboard.stories.title",
        component: "Stories",
      })
    },
    ranking() {
      this.push({
        singleton: true,
        name: "dashboard.ranking.title",
        component: "Ranking",
      })
    },
    groups() {
      this.push({
        singleton: true,
        name: "dashboard.groups.title",
        component: "Groups",
      })
    },
    documentation() {
      this.push({
        singleton: true,
        name: "dashboard.documentation.title",
        component: "Documentation",
      })
    },
    notifications() {
      this.push({
        singleton: true,
        name: "dashboard.notifications.title",
        component: "Notifications",
      })
    },
    extension() {
      window.open("https://chrome.google.com/webstore/detail/securating/acnjambicelkgkphdpmaoheaomabopkg", "_blank")
    },
  },
}
</script>
